import { useState } from "react";
import { format, parseISO } from "date-fns";
import { enGB } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DatePicker = ({ value, onChange, placeholder = "DD/MM/YYYY", clearable = false, testId, className, id, ...rest }) => {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  const pick = (d) => {
    if (d) onChange(format(d, "yyyy-MM-dd"));
    setOpen(false);
  };
  return (
    <div className={cn("relative", className)}>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button id={id} type="button" variant="outline" data-testid={testId} {...rest}
            className={cn("w-full justify-start font-normal", !date && "text-slate-500", clearable && date && "pr-9")}>
            <CalendarDays className="mr-2 h-4 w-4 shrink-0 text-slate-500" />
            <span className="font-data">{date ? format(date, "dd/MM/yyyy") : placeholder}</span>
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar mode="single" locale={enGB} weekStartsOn={1} selected={date} defaultMonth={date} onSelect={pick} initialFocus />
        </PopoverContent>
      </Popover>
      {clearable && date && (
        <button type="button" onClick={() => onChange("")} aria-label="Clear date" data-testid={testId && `${testId}-clear`}
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-700">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
